<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<dialog-titlebar [title]="itemType.pluralDisplay"></dialog-titlebar>
<div mat-dialog-content>
	<mat-slide-toggle content="extraControls" [formControl]="showHiddenCustomFieldControl">
		{{ strings.CUSTOM_FIELD_SHOW_ON_HIDDEN_TICKET }}
	</mat-slide-toggle>
	<app-item-list
		#fieldList
		customHeight="526px"
		[itemType]="itemType"
		[itemList]="customFieldList$ | async"
		[editor]="self"
		[highlightItemInEdit]="true"
		[enableItemDragAndDrop]="!hasFilter"
		[hideItemList]="resetCustomFieldListObs$ | async"
	>
		<!-- itemEditor:  injecting edit item panel. new definition will be the editing case as well with the new local update approach -->
		<add-edit-custom-field
			itemEditor
			#fieldEditor
			class="full-width full-height"
			[item]="itemInEdit"
			[editorMode]="editorMode"
			(memberCommitEvent)="completeEdit($event)"
			(itemFormEvent)="handleItemForm($event)"
		>
		</add-edit-custom-field>
	</app-item-list>
</div>
